import { JsonObject } from 'json2typescript';
import GoodsOption from './GoodsOption';
import CartItem from './CartItem';

@JsonObject('CartItemGoods')
export default class CartItemGoods extends CartItem {
  constructor() {
    super();
    this.goodsCode = '';
    this.goodsTitle = '';
    this.goodsItemOptions = new Array<GoodsOption>();
  }

  public get code(): string {
    return this.goodsCode;
  }

  public set code(v: string) {
    this.goodsCode = v;
  }

  public get title(): string {
    return this.goodsTitle;
  }

  public set title(v: string) {
    this.goodsTitle = v;
  }

  public get options(): { typeTitle: string; title: string }[] {
    return this.goodsItemOptions.map((v) => ({ typeTitle: v.goodsOptionTypeTitle, title: v.optionTitle }));
  }

  public goodsCode: string;

  public goodsTitle: string;

  public goodsItemOptions: Array<GoodsOption>;
}
